import type { TranslationKey } from '@/lib/i18n';

export const CART_HEADER_CLOSE = [
  'sidecart:cart.close',
  'Close',
] as const satisfies TranslationKey;

export const CART_HEADER_TITLE = [
  'sidecart:cart.title',
  'My Bag',
] as const satisfies TranslationKey;

export const CART_HEADER_ITEMS = [
  'sidecart:cart.items',
  '{{count}} item',
] as const satisfies TranslationKey;
